import React from 'react';
import { useHistory } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  LinearProgress,
  Typography,
  makeStyles,
  colors
} from '@material-ui/core';
import InsertChartIcon from '@material-ui/icons/InsertChartOutlined';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    background: '#24b324',
    marginTop: 10,
    cursor: 'pointer'
  },
  avatar: {
    backgroundColor: colors.orange[600],
    height: 56,
    width: 56
  }
}));

const Finalizados = ({ valor, className, ...rest }) => {
  const classes = useStyles();
  const history = useHistory();

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
      onClick={() => {
        history.push('/app/atendimentos/finalizado');
      }}
    >
      <CardContent>
        <Grid container justify="space-between" spacing={3}>
          <Grid item>
            <Typography style={{ color: '#f2f4f5' }} gutterBottom variant="h6">
              Atendimentos Finalizados
            </Typography>
            <Typography style={{ color: '#f2f4f5' }} variant="h1">
              {valor}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

Finalizados.propTypes = {
  className: PropTypes.string
};

export default Finalizados;
